export interface CommunityTopic {
  id: string;
  title: string;
  author: string;
  avatar: string;
  replies: number;
  updatedAt: string;
  board: string;
  tags: string[];
  content: string[];
}

export const communityBoards = [
  { key: 'hot', name: '热门话题', icon: 'ri-fire-line' },
  { key: 'latest', name: '最新讨论', icon: 'ri-time-line' },
  { key: 'following', name: '我的关注', icon: 'ri-heart-line' },
];

export const topics: CommunityTopic[] = [
  {
    id: 'topic-1',
    title: '大家最近都在用哪些好用的效率工具？来互相安利一下',
    author: '南风知我意',
    avatar: 'N',
    replies: 186,
    updatedAt: '2026-10-09 21:40',
    board: 'hot',
    tags: ['效率', '工具', '讨论'],
    content: [
      '最近在整理自己的工作流，发现好的工具真的能省下不少时间，所以想开个帖子收集一下大家的私藏。',
      '我自己常用的是笔记加看板组合，任务、资料、灵感都放在一起，找起来特别方便。你们平时都有哪些离不开的工具？',
    ],
  },
  {
    id: 'topic-2',
    title: '最近读到一本特别治愈的书，想和大家聊聊阅读这件事',
    author: '慢半拍',
    avatar: '慢',
    replies: 124,
    updatedAt: '2026-10-09 19:05',
    board: 'hot',
    tags: ['阅读', '生活', '分享'],
    content: [
      '上周偶然翻到一本散文集，文字很轻，却让人安静下来。突然觉得阅读不只是获取信息，更像是一种休息。',
      '想问问大家，你们最近在读什么？有没有那种读完之后会想推荐给别人的书？',
    ],
  },
  {
    id: 'topic-3',
    title: '城市里最适合一个人去的角落，分享一下你的私藏地点',
    author: '一只鹿',
    avatar: '鹿',
    replies: 98,
    updatedAt: '2026-10-09 16:22',
    board: 'latest',
    tags: ['城市', '旅行', '生活'],
    content: [
      '越来越喜欢一个人在城市里闲逛，不用迁就别人的节奏，看到喜欢的店就进去坐坐。',
      '想收集一些适合独处的角落：安静的咖啡馆、傍晚的江边、旧书店之类的，先谢谢各位的分享啦。',
    ],
  },
  {
    id: 'topic-4',
    title: '关于新能源车，老车主们可以给准备入手的人一些建议吗',
    author: '电波少年',
    avatar: '电',
    replies: 213,
    updatedAt: '2026-10-09 14:10',
    board: 'hot',
    tags: ['新能源', '汽车', '求助'],
    content: [
      '准备入手人生第一台新能源车，看参数看得有点眼花，想听听真实车主的长期使用感受。',
      '主要关心续航衰减、充电便利性和后期保养成本，有经验的朋友欢迎来聊聊。',
    ],
  },
  {
    id: 'topic-5',
    title: '周末在家做饭，分享一道零失败的家常菜做法',
    author: '厨房小白进阶中',
    avatar: '厨',
    replies: 76,
    updatedAt: '2026-10-09 11:35',
    board: 'latest',
    tags: ['美食', '厨房', '分享'],
    content: [
      '作为一个厨房新手，终于摸索出一道怎么都不会翻车的小炒，食材简单，十分钟出锅。',
      '关键就是提前把调料兑好，下锅后不用手忙脚乱。步骤我写在下面，欢迎大家交流做法。',
    ],
  },
  {
    id: 'topic-6',
    title: '你有多久没有好好休息了？聊聊大家的解压方式',
    author: '云上的日子',
    avatar: '云',
    replies: 152,
    updatedAt: '2026-10-08 22:18',
    board: 'hot',
    tags: ['生活', '健康', '讨论'],
    content: [
      '最近感觉整个人都很紧绷，试了几种解压方式，发现散步和听音乐对我最有效。',
      '想听听大家的解压妙招，也许能帮到和我一样需要喘口气的人。',
    ],
  },
  {
    id: 'topic-7',
    title: '新出的折叠屏值得入手吗？用过的朋友来说说真实体验',
    author: '数码观察员',
    avatar: '数',
    replies: 64,
    updatedAt: '2026-10-08 18:42',
    board: 'latest',
    tags: ['数码', '手机', '求助'],
    content: [
      '新一代折叠屏看起来轻薄了不少，但价格还是不便宜，纠结要不要入手。',
      '最担心的是折痕和耐用性，有没有长期使用的朋友给个参考？',
    ],
  },
  {
    id: 'topic-8',
    title: '分享一个让我坚持早起的小方法，简单但真的有用',
    author: '清晨六点',
    avatar: '晨',
    replies: 89,
    updatedAt: '2026-10-08 07:15',
    board: 'latest',
    tags: ['习惯', '生活', '分享'],
    content: [
      '试过很多方法，最后发现最有效的居然是前一晚把手机放到客厅充电。',
      '没有手机可刷，第二天自然就早起了。简单粗暴，但对我真的很管用。',
    ],
  },
  {
    id: 'topic-9',
    title: '博物馆夜游体验如何？去过的朋友来聊聊',
    author: '看展爱好者',
    avatar: '展',
    replies: 57,
    updatedAt: '2026-10-07 20:30',
    board: 'following',
    tags: ['文化', '博物馆', '体验'],
    content: [
      '看到好几家博物馆都开放夜场，很心动，但不确定夜间观展体验怎么样。',
      '想问问去过的人，人流量、灯光和讲解安排如何，值不值得专门跑一趟？',
    ],
  },
  {
    id: 'topic-10',
    title: '最近的综艺你们都在追哪一部？来交换片单',
    author: '周末沙发瘫',
    avatar: '周',
    replies: 103,
    updatedAt: '2026-10-07 13:55',
    board: 'following',
    tags: ['综艺', '影视', '分享'],
    content: [
      '最近迷上了几档慢综艺，看着别人慢悠悠地生活，自己好像也跟着放松了。',
      '大家有没有正在追的节目？类型不限，好内容都欢迎推荐。',
    ],
  },
];